<template>
  <div>
    <el-dialog
      :title="`${action === 'add' ? 'Add New' : 'Edit'} Meal Category`"
      :visible.sync="setShow"
      append-to-body
      width="30%"
    >
      <el-form :model="form" label-position="top" ref="form">
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item
              label="Category name"
              prop="category"
              :rules="validateField()"
            >
              <el-input type="text" v-model="form.category" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="close">Cancel</el-button>
        <el-button type="primary" @click="save" :loading="updating">{{
          action === "add" ? "Add" : "Save changes"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import categories from "@/requests/services/meal/categories";

export default {
  name: "MealCategoryForm",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: "add",
    },
    category: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        category: "",
      },
      adding: false,
      updating: false,
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.action === "edit") {
          this.form.category = this.formatText(this.category.category);
        }
      }
    },
  },
  methods: {
    close() {
      this.setShow = false;
      this.form.category = "";
    },
    save() {
      this.action === "add" ? this.add() : this.update();
    },
    add() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.updating = true;
        categories
          .add(this.form)
          .then((response) => {
            if (response.data.status) {
              this.updating = false;
              this.$message.success(response.data.message);
              this.$emit("success");
              this.close();
            } else {
              this.updating = false;
            }
          })
          .catch((error) => {
            this.updating = false;
            const errorMessage = error.response.data;
            if (errorMessage.errors) {
              const errorKeys = Object.keys(errorMessage.errors);
              this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
            } else {
              this.$message.error(errorMessage.message);
            }
          });
      });
    },
    update() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.updating = true;
        categories
          .update(this.category.id, this.form)
          .then((response) => {
            if (response.data.status) {
              this.updating = false;
              this.$message.success(response.data.message);
              this.$emit("success");
              this.close();
            } else {
              this.updating = false;
            }
          })
          .catch((error) => {
            this.updating = false;
            const errorMessage = error.response.data;
            if (errorMessage.errors) {
              const errorKeys = Object.keys(errorMessage.errors);
              this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
            } else {
              this.$message.error(errorMessage.message);
            }
          });
      });
    },
  },
};
</script>
